import consumer from "../channels/consumer";

let queueingV2TvSubscription;
let fallbackTimerId;

const clearFallbackPolling = () => {
  if (fallbackTimerId) {
    clearInterval(fallbackTimerId);
    fallbackTimerId = null;
  }
};

const teardownQueueingV2TvRefresher = () => {
  clearFallbackPolling();

  if (queueingV2TvSubscription) {
    consumer.subscriptions.remove(queueingV2TvSubscription);
    queueingV2TvSubscription = null;
  }
};

const queueingV2TvRefresher = () => {
  teardownQueueingV2TvRefresher();

  const container = document.querySelector("[data-queueing-v2-tv]");

  if (!container) {
    return;
  }

  const sourceUrl = container.dataset.sourceUrl;
  const branchId = container.dataset.branchId;
  const fallbackInterval = Number(container.dataset.fallbackInterval || 30000);

  if (!sourceUrl || !branchId) {
    return;
  }

  let refreshInFlight = false;
  let hasConnected = false;

  const refreshGrid = () => {
    const currentGrid = document.querySelector("[data-queueing-v2-tv-grid]");

    if (!currentGrid || refreshInFlight) {
      return;
    }

    refreshInFlight = true;

    fetch(sourceUrl, {
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => response.text())
      .then((html) => {
        currentGrid.outerHTML = html;
      })
      .catch((error) => {
        console.log({ error });
      })
      .finally(() => {
        refreshInFlight = false;
      });
  };

  const startFallbackPolling = () => {
    if (fallbackTimerId) {
      return;
    }

    fallbackTimerId = setInterval(refreshGrid, fallbackInterval);
  };

  const replaceCategoryCard = (categoryId, html) => {
    const currentCard = document.querySelector(`[data-queueing-category-card][data-queueing-station-category-id="${categoryId}"]`);

    if (!currentCard) {
      refreshGrid();
      return;
    }

    currentCard.outerHTML = html;
  };

  queueingV2TvSubscription = consumer.subscriptions.create(
    { channel: "QueueingV2TvChannel", branch_id: branchId },
    {
      connected() {
        clearFallbackPolling();

        if (hasConnected) {
          refreshGrid();
          return;
        }

        hasConnected = true;
      },

      disconnected() {
        startFallbackPolling();
      },

      received(data) {
        if (!data || !data.type) {
          return;
        }

        if (data.type === "category_card") {
          replaceCategoryCard(data.category_id, data.html);
          return;
        }

        if (data.type === "grid_refresh") {
          const currentGrid = document.querySelector("[data-queueing-v2-tv-grid]");

          if (currentGrid) {
            currentGrid.outerHTML = data.html;
          }
        }
      }
    }
  );
};

document.addEventListener("turbolinks:before-cache", teardownQueueingV2TvRefresher);

export default queueingV2TvRefresher;
